export const TextEffectsSharedViewerType = 'wixui.TextEffectsShared' as const;

export const TextEffectsSharedData = 'TextEffectsSharedData';

export const TestIds = {
  viewer: {
    link: 'text-effects-shared-link',
  },
} as const;

export const HEADING_LEVELS = {
  H1: 1,
  H2: 2,
  H3: 3,
  H4: 4,
  H5: 5,
  H6: 6,
  P: 0,
  '⏤': -1,
} as const;

export type HeadingLevel = keyof typeof HEADING_LEVELS;

export const COLOR_PICKER_X_OFFSET = 0;
export const COLOR_PICKER_Y_OFFSET = 35;

export const MIN_FONT = 8;
export const MAX_FONT = 999;

export const dataHooks = {
  root: 'text-effect',
  settings: {
    textInput: 'settings-text-input',
    textInputLabel: 'settings-text-input-label',
    textDirection: 'settings-text-direction',
    textDirectionToggle: 'settings-text-direction-toggle',
  },
  design: {
    colorSwatch: 'color-swatch',
    colorSwatches: 'color-swatches',
    themesDropdown: 'text-effects-shared-font-themes-dropdown',
    fontFamilyPicker: 'text-effects-shared-font-family-picker',
    fontSizeInput: 'text-effects-shared-font-size-input',
    textCollapsibleLabel: 'text-effects-shared-text-collapsible-label',
    textStylesList: 'text-effects-shared-text-styles-list',
    textAlignList: 'text-effects-shared-text-align-list',
    textTransformList: 'text-effects-shared-text-transform-list',
    lineHeightInput: 'text-effects-shared-line-height-input',
    letterSpacingInput: 'text-effects-shared-letter-spacing-input',
    maxMinFontSize: 'text-effects-shared-max-min-font-size',
    maxFontSizeInput: 'text-effects-shared-max-font-size-input',
    textDirectionList: 'text-effects-shared-text-direction-list',
    headingTagDropdown: 'text-effects-shared-heading-tag-dropdown',
    isDecorativeCheckbox: 'text-effects-shared-is-decorative-checkbox',
    borderColorSelect: 'text-effects-shared-border-color-select',
    borderWidthSlider: 'text-effects-shared-border-width-slider',
    borderWidthInput: 'text-effects-shared-border-width-input',
    layerSpacingInput: 'text-effects-shared-layer-spacing-input',
    bevelAngleInput: 'text-effects-shared-bevel-angle-input',
  },
};

export const helpIds = {
  gfpp: 'ae8ce04f-3d77-4811-8804-63c110f42cea',
  settings: 'ae8ce04f-3d77-4811-8804-63c110f42cea',
};

export const blendModes = [
  { value: 'normal', label: 'Normal' },
  { value: 'color', label: 'Color' },
  { value: 'color-burn', label: 'Color burn' },
  { value: 'color-dodge', label: 'Color dodge' },
  { value: 'darken', label: 'Darken' },
  { value: 'difference', label: 'Difference' },
  { value: 'exclusion', label: 'Exclusion' },
  { value: 'hard-light', label: 'Hard light' },
  { value: 'hue', label: 'Hue' },
  { value: 'lighten', label: 'Lighten' },
  { value: 'luminosity', label: 'Luminosity' },
  { value: 'multiply', label: 'Multiply' },
  { value: 'overlay', label: 'Overlay' },
  { value: 'saturation', label: 'Saturation' },
  { value: 'screen', label: 'Screen' },
  { value: 'soft-light', label: 'Soft light' },
] as const;
